import React, { useContext, useEffect, useRef, useState } from "react";
import "../css/paysuccess.css";
import { Link, useSearchParams } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import { CartContext } from "./CartContext";

const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const clearedRef = useRef(false);
  const result = searchParams.get("state");
  const isSuccess = result === "success";
  const isCancel = result === "cancel";
  const [order] = useState(() => {
    try {
      return JSON.parse(window.sessionStorage.getItem("yorthmarketco-pending-order")) || {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    document.title = `${isSuccess ? "Payment successful" : "Payment not completed"} — ${siteConfig.brandName}`;
    if (isSuccess && !clearedRef.current) {
      clearedRef.current = true;
      clearCart();
      window.sessionStorage.removeItem("yorthmarketco-pending-order");
    }
  }, [clearCart, isSuccess]);

  return (
    <main className="success-page">
      <div className="success-page__mark" aria-hidden="true">{isSuccess ? "✓" : "×"}</div>
      <p className="success-page__eyebrow">
        {isSuccess ? "Payment successful" : isCancel ? "Payment cancelled" : "Payment status unavailable"}
      </p>
      <h1>{isSuccess ? "Thank you for your order." : "Your order was not completed."}</h1>
      <p className="success-page__copy">
        {isSuccess
          ? `We are preparing your selection. A confirmation will be sent to ${order.email || "the email address provided at checkout"}.`
          : "No completed payment has been recorded. Your items remain in the bag so you can review the order and try again."}
      </p>
      <dl>
        {order.orderNumber && <div><dt>Order</dt><dd>{order.orderNumber}</dd></div>}
        {order.total && <div><dt>Total</dt><dd>{formatPrice(order.total)}</dd></div>}
        <div><dt>Status</dt><dd>{isSuccess ? "Confirmed" : "Not paid"}</dd></div>
      </dl>
      <div className="success-page__actions">
        <Link to={isSuccess ? "/shop" : "/checkout"}>{isSuccess ? "Continue shopping" : "Return to checkout"}</Link>
        <a href={`mailto:${siteConfig.contact.email}`}>Contact client care</a>
      </div>
    </main>
  );
};

export default PaymentResult;
